/** @format */

export const REGISTER_USER = 'REGISTER_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const DUPLICATE_NICKNAME_CHECK = 'DUPLICATE_NICKNAME_CHECK';
export const SET_STATE = 'SET_STATE';
